import { createContext, useContext } from 'react'
import type { AttendanceSectionConfig } from '../../types'

/**
 * The section's config + handlers, read by the grid's cell and header
 * components. AG Grid's React renderers mount inside the AgGridReact tree, so a
 * provider around the grid reaches them — and, unlike the grid's own `context`
 * option, a change here re-renders every consumer.
 */
export const AttendanceSectionContext =
  createContext<AttendanceSectionConfig | null>(null)

export const useAttendanceSection = (): AttendanceSectionConfig => {
  const config = useContext(AttendanceSectionContext)
  if (!config) {
    throw new Error(
      'useAttendanceSection must be used inside AttendanceSectionContext'
    )
  }
  return config
}
